import { render, staticRenderFns } from "./FooterTop.vue?vue&type=template&id=727f7938&"
import script from "./FooterTop.vue?vue&type=script&lang=js&"
export * from "./FooterTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports